/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const OPTED_COMMUNICATION = 'PROMO';

export type OptInEvents =
  | 'optInPromoEmailOffers'
  | 'optInPromoSmsOffers'
  | 'optInPromoSMS+EmailOffers';
